







































































































































































































import {
  computed, defineComponent, reactive, Ref, ref,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';
import _ from 'lodash';

import CommonCheckBoxRenderer from '@/components/CommonCheckBoxRenderer.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithSubJobEditor from '@/components/Job/CommonModalWithSubJobEditor.vue';
import CommonModalWithSubJobStationUpdate from '@/components/Job/CommonModalWithSubJobStationUpdate.vue';
import CommonModalWithSubJobDuplicate from '@/components/Job/CommonModalWithSubJobDuplicate.vue';
import CommonModalWithAmountStatusUpdate from '@/components/Job/CommonModalWithAmountStatusUpdate.vue';

import {
  getJobs,
  getSubJobsForInternalTab,
  updateSubJob,
  duplicateSubJob,
  massUpdateSubJob,
} from '@/api';
import subJobQC from '@/table/Job/SubJob/subJob-qc';
import progressQC from '@/table/Job/SubJob/qc-progress';
import heat from '@/table/Job/SubJob/heat';
import surface from '@/table/Job/SubJob/surface';
import production from '@/table/Job/SubJob/production';
import claim from '@/table/Job/SubJob/claim';
import store from '@/table/Job/SubJob/store';
import useAuth from '@/use/useAuth';
import useDownloadReport from '@/use/useDownloadReport';
import useSubJob from '@/use/useSubJob';

const NOW: string = useFormat.date().computerShortDate();
const { qcStatusEN, qcStatusTH, statusToQCAmountColumn } = useSubJob();

const presetFilters = [
  {
    name: '0',
    display: 'ทั้งหมด',
    table: subJobQC,
    amountColumn: 'amount',
    filterProcessStatus: 'QC',
    filterExceptStatus: 'CANCELLED',
  },
  {
    name: '1',
    display: 'รับเข้า QC',
    table: progressQC,
    amountColumn: statusToQCAmountColumn('QC_PROGRESS'),
    filterQCProgressAmount: 0,
    filterExceptStatus: 'CANCELLED',
  },
  {
    name: '2',
    display: 'Surface Treatment',
    table: surface,
    amountColumn: statusToQCAmountColumn('SURFACE_TREATMENT'),
    filterQCSurfaceAmount: 0,
    filterExceptStatus: 'CANCELLED',
    withSurfaceTreatmentPurchaseRequest: true,
  },
  {
    name: '3',
    display: 'Heat Treatment',
    table: heat,
    amountColumn: statusToQCAmountColumn('HEAT_TREATMENT'),
    filterQCHeatAmount: 0,
    filterExceptStatus: 'CANCELLED',
    withHeatTreatmentPurchaseRequest: true,
  },
  {
    name: '4',
    display: 'ส่งต่อ Production',
    table: production,
    amountColumn: statusToQCAmountColumn('PRODUCTION'),
    filterQCProductionAmount: 0,
    filterExceptStatus: 'CANCELLED',
  },
  {
    name: '5',
    display: 'งานเคลม',
    table: claim,
    amountColumn: statusToQCAmountColumn('CLAIM'),
    filterQCClaimAmount: 0,
    filterExceptStatus: 'CANCELLED',
  },
  {
    name: '6',
    display: 'เข้า Store',
    table: store,
    amountColumn: statusToQCAmountColumn('STORE'),
    filterQCStoreAmount: 0,
    filterExceptStatus: 'CANCELLED',
  },
];

const SubJobList = defineComponent({
  components: {
    CommonCheckBoxRenderer,
    CommonModalWithPreset,
    CommonModalWithSubJobEditor,
    CommonModalWithSubJobStationUpdate,
    CommonModalWithSubJobDuplicate,
    CommonModalWithAmountStatusUpdate,
  },
  setup(props, { emit, root }) {
    const { route, router } = useRouter();
    const { getReport, getCSVReport } = useDownloadReport();
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const selectedFilterIndex = ref('0');
    const getJobResult = (data: any) => data.data.data;
    const selectedJob = ref(null);
    const search = ref('');
    const editSubJobModal = ref(null);
    const subJobTable = ref(null);

    const refetchQuery = ref(false);
    const computedFilter = computed(() => {
      const vars = {
        ...presetFilters[selectedFilterIndex.value as any],
        filterBomIds: undefined,
        searchString: undefined,
        name: undefined,
        display: undefined,
        table: undefined,
      };

      if (selectedJob.value) {
        vars.filterBomIds = [(selectedJob.value as any).id] as any;
      }
      if (search.value) {
        vars.searchString = search.value as any;
      }
      return vars;
    });

    const pendingSearch = _.debounce(() => { refetchQuery.value = true; }, 250);
    const totalItems = ref(0);

    async function updateSingleSubJobStatus(item: any, payload: any) {
      (updateAmountWithStatusModal.value as any).compose({
        items: [item],
        ...payload,
        text: payload.qc_status,
        old_column: presetFilters[selectedFilterIndex.value as any].amountColumn,
      });
    }

    // Use with select box
    const selectedItemId: Ref<number[]> = ref([]);
    const selectedItem: Ref<any[]> = ref([]);
    async function updateSubJobStatus(id: any, payload: any) {
      await updateSubJob(id, payload);
      refetchQuery.value = true;
      selectedItemId.value = [];
      selectedItem.value = [];
      emit('pendingRefetchQuery');
    }

    const tableData = ref([]);
    function handlerFetchData(queryData: any) {
      const { data, from, to } = queryData;
      totalItems.value = (to - from) + 1;
      tableData.value = data;
    }
    function handleSelectAllItem($event: any[]) {
      if (selectedItemId.value.length === tableData.value.length) {
        selectedItemId.value = [];
        selectedItem.value = [];
      } else {
        selectedItemId.value = $event;
        selectedItem.value = tableData.value;
      }
    }
    const selectedAll = computed(() => selectedItemId.value.length === totalItems.value);

    // Use sub job click row
    const subJobStatusUpdateModal = ref(null);
    function subJobTableClickRowHandler(row: any) {
      if (hasPermission('bom.items.station')) (subJobStatusUpdateModal.value as any).compose(row.item.id);
      else if (hasPermission('bom.items.manage')) (editSubJobModal.value as any).open(row.item.id);
    }

    function selectItem(id: number | string, item: any) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) {
        selectedItemId.value.splice(hitIndex, 1);
        selectedItem.value.splice(hitIndex, 1);
      } else {
        selectedItemId.value.push(parseInt(id as string, 10));
        selectedItem.value.push(item);
      }
    }
    // Use to mass update sub job status
    const updateAmountWithStatusModal = ref(null);
    async function massUpdateStatus(payload: any) {
      (updateAmountWithStatusModal.value as any).compose({
        items: selectedItem.value,
        ...payload,
        text: payload.qc_status,
        old_column: presetFilters[selectedFilterIndex.value as any].amountColumn,
      });
    }

    function navigateToCreateTreatmentRequestAction() {
      router.push({
        name: 'PurchaseRequestCreateTreatment',
        query: {
          instantSearch: selectedItemId.value,
        },
      });
    }

    const duplicateSubJobModal = ref(null);

    function tabChangeHandler(tabName: string) {
      selectedFilterIndex.value = tabName;
      selectedItemId.value = [];
      selectedItem.value = [];
      pendingSearch();
    }

    const treatmentSelectModal = ref(null);
    const pendingToEditTreatment = reactive({
      item: -1,
      payload: {},
    });
    function openTreatmentSelectModal(item: any, payload: any) {
      pendingToEditTreatment.item = item;
      pendingToEditTreatment.payload = payload;
      (treatmentSelectModal.value as any).open();
    }

    const csv: { range: any; status: string[] } = reactive({
      range: {
        from: NOW,
        to: NOW,
      },
      status: [],
    });
    function selectExportStatus(status: string) {
      const index = csv.status.indexOf(status);
      if (index > -1) csv.status.splice(index, 1);
      else csv.status.push(status);
    }
    function exportCSV() {
      if (csv.status.length > 0) {
        csv.status.forEach((s: string) => {
          getCSVReport('bom_items', 'csv-qc', `[${csv.range.from}] ${s}-bom`, {
            filterStatus: s,
            from: csv.range.from,
            to: csv.range.to,
          });
        });
      } else {
        getCSVReport('bom_items', 'csv-qc', `[${csv.range.from}] qc`, {
          from: csv.range.from,
          to: csv.range.to,
        });
      }
    }

    const amountUpdatePayload = reactive({
      amount: 0,
    });

    return {
      qcStatusEN,
      qcStatusTH,

      presetFilters,
      getJobs,
      getSubJobsForInternalTab,
      getJobResult,
      subJobTable,
      editSubJobModal,

      search,
      selectedJob,
      selectedFilterIndex,
      computedFilter,
      tabChangeHandler,

      pendingSearch,
      handlerFetchData,
      refetchQuery,

      duplicateSubJob,
      duplicateSubJobModal,

      subJobStatusUpdateModal,
      subJobTableClickRowHandler,
      selectedItemId,
      selectItem,
      massUpdateStatus,
      handleSelectAllItem,
      selectedAll,
      updateSubJobStatus,
      updateSingleSubJobStatus,

      navigateToCreateTreatmentRequestAction,

      treatmentSelectModal,
      openTreatmentSelectModal,
      pendingToEditTreatment,

      csv,
      selectExportStatus,
      exportCSV,

      amountUpdatePayload,
      updateAmountWithStatusModal,
    };
  },
});

export default SubJobList;
